"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoTestTestStepOutput = exports.AutoTestTestStepInput = exports.AutoTestRedactedTestStepOutput = exports.EditorFileType = exports.PutPearsonQuestionSource = void 0;
var PutPearsonQuestionSource;
(function (PutPearsonQuestionSource) {
    PutPearsonQuestionSource.visit = (value, visitor) => {
        if (value.coding !== undefined)
            return visitor.coding(value.coding);
        if (value.multipleChoice !== undefined)
            return visitor.multipleChoice(value.multipleChoice);
        if (value.selectAll !== undefined)
            return visitor.selectAll(value.selectAll);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(PutPearsonQuestionSource || (exports.PutPearsonQuestionSource = PutPearsonQuestionSource = {}));
var EditorFileType;
(function (EditorFileType) {
    EditorFileType.visit = (value, visitor) => {
        if (value.directory !== undefined)
            return visitor.directory(value.directory);
        if (value.regular !== undefined)
            return visitor.regular(value.regular);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EditorFileType || (exports.EditorFileType = EditorFileType = {}));
var AutoTestRedactedTestStepOutput;
(function (AutoTestRedactedTestStepOutput) {
    AutoTestRedactedTestStepOutput.visit = (value, visitor) => {
        if (value.testHide !== undefined)
            return visitor.testHide(value.testHide);
        if (value.runIn !== undefined)
            return visitor.runIn(value.runIn);
        if (value.runIf !== undefined)
            return visitor.runIf(value.runIf);
        if (value.allowInternet !== undefined)
            return visitor.allowInternet(value.allowInternet);
        if (value.connectRubric !== undefined)
            return visitor.connectRubric(value.connectRubric);
        if (value.weight !== undefined)
            return visitor.weight(value.weight);
        if (value.checkstyle !== undefined)
            return visitor.checkstyle(value.checkstyle);
        if (value.javaCompile !== undefined)
            return visitor.javaCompile(value.javaCompile);
        if (value.junit5 !== undefined)
            return visitor.junit5(value.junit5);
        if (value.customTest !== undefined)
            return visitor.customTest(value.customTest);
        if (value.testTimeoutEach !== undefined)
            return visitor.testTimeoutEach(value.testTimeoutEach);
        if (value.flake8 !== undefined)
            return visitor.flake8(value.flake8);
        if (value.pytest !== undefined)
            return visitor.pytest(value.pytest);
        if (value.simplePythonTest !== undefined)
            return visitor.simplePythonTest(value.simplePythonTest);
        if (value.jupyterNotebook !== undefined)
            return visitor.jupyterNotebook(value.jupyterNotebook);
        if (value.runInNotebook !== undefined)
            return visitor.runInNotebook(value.runInNotebook);
        if (value.output !== undefined)
            return visitor.output(value.output);
        if (value.testUploadFiles !== undefined)
            return visitor.testUploadFiles(value.testUploadFiles);
        if (value.snapshot !== undefined)
            return visitor.snapshot(value.snapshot);
        if (value.ioTest !== undefined)
            return visitor.ioTest(value.ioTest);
        if (value.simpleMatch !== undefined)
            return visitor.simpleMatch(value.simpleMatch);
        if (value.regexMatch !== undefined)
            return visitor.regexMatch(value.regexMatch);
        if (value.substringMatch !== undefined)
            return visitor.substringMatch(value.substringMatch);
        if (value.codeStructureTest !== undefined)
            return visitor.codeStructureTest(value.codeStructureTest);
        if (value.negativeMatch !== undefined)
            return visitor.negativeMatch(value.negativeMatch);
        if (value.positiveMatch !== undefined)
            return visitor.positiveMatch(value.positiveMatch);
        if (value.quiz !== undefined)
            return visitor.quiz(value.quiz);
        if (value.codingQuestion !== undefined)
            return visitor.codingQuestion(value.codingQuestion);
        if (value.promptEngineeringQuestion !== undefined)
            return visitor.promptEngineeringQuestion(value.promptEngineeringQuestion);
        if (value.mcq !== undefined)
            return visitor.mcq(value.mcq);
        if (value.selectAllQuestion !== undefined)
            return visitor.selectAllQuestion(value.selectAllQuestion);
        if (value.program !== undefined)
            return visitor.program(value.program);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedTestStepOutput || (exports.AutoTestRedactedTestStepOutput = AutoTestRedactedTestStepOutput = {}));
var AutoTestTestStepInput;
(function (AutoTestTestStepInput) {
    AutoTestTestStepInput.visit = (value, visitor) => {
        if (value.testHide !== undefined)
            return visitor.testHide(value.testHide);
        if (value.runIn !== undefined)
            return visitor.runIn(value.runIn);
        if (value.runIf !== undefined)
            return visitor.runIf(value.runIf);
        if (value.allowInternet !== undefined)
            return visitor.allowInternet(value.allowInternet);
        if (value.connectRubric !== undefined)
            return visitor.connectRubric(value.connectRubric);
        if (value.weight !== undefined)
            return visitor.weight(value.weight);
        if (value.checkstyle !== undefined)
            return visitor.checkstyle(value.checkstyle);
        if (value.javaCompile !== undefined)
            return visitor.javaCompile(value.javaCompile);
        if (value.junit5 !== undefined)
            return visitor.junit5(value.junit5);
        if (value.customTest !== undefined)
            return visitor.customTest(value.customTest);
        if (value.testTimeoutEach !== undefined)
            return visitor.testTimeoutEach(value.testTimeoutEach);
        if (value.flake8 !== undefined)
            return visitor.flake8(value.flake8);
        if (value.pytest !== undefined)
            return visitor.pytest(value.pytest);
        if (value.simplePythonTest !== undefined)
            return visitor.simplePythonTest(value.simplePythonTest);
        if (value.jupyterNotebook !== undefined)
            return visitor.jupyterNotebook(value.jupyterNotebook);
        if (value.runInNotebook !== undefined)
            return visitor.runInNotebook(value.runInNotebook);
        if (value.output !== undefined)
            return visitor.output(value.output);
        if (value.testUploadFiles !== undefined)
            return visitor.testUploadFiles(value.testUploadFiles);
        if (value.snapshot !== undefined)
            return visitor.snapshot(value.snapshot);
        if (value.ioTest !== undefined)
            return visitor.ioTest(value.ioTest);
        if (value.simpleMatch !== undefined)
            return visitor.simpleMatch(value.simpleMatch);
        if (value.regexMatch !== undefined)
            return visitor.regexMatch(value.regexMatch);
        if (value.substringMatch !== undefined)
            return visitor.substringMatch(value.substringMatch);
        if (value.codeStructureTest !== undefined)
            return visitor.codeStructureTest(value.codeStructureTest);
        if (value.negativeMatch !== undefined)
            return visitor.negativeMatch(value.negativeMatch);
        if (value.positiveMatch !== undefined)
            return visitor.positiveMatch(value.positiveMatch);
        if (value.quiz !== undefined)
            return visitor.quiz(value.quiz);
        if (value.codingQuestion !== undefined)
            return visitor.codingQuestion(value.codingQuestion);
        if (value.promptEngineeringQuestion !== undefined)
            return visitor.promptEngineeringQuestion(value.promptEngineeringQuestion);
        if (value.mcq !== undefined)
            return visitor.mcq(value.mcq);
        if (value.selectAllQuestion !== undefined)
            return visitor.selectAllQuestion(value.selectAllQuestion);
        if (value.program !== undefined)
            return visitor.program(value.program);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestTestStepInput || (exports.AutoTestTestStepInput = AutoTestTestStepInput = {}));
var AutoTestTestStepOutput;
(function (AutoTestTestStepOutput) {
    AutoTestTestStepOutput.visit = (value, visitor) => {
        if (value.testHide !== undefined)
            return visitor.testHide(value.testHide);
        if (value.runIn !== undefined)
            return visitor.runIn(value.runIn);
        if (value.runIf !== undefined)
            return visitor.runIf(value.runIf);
        if (value.allowInternet !== undefined)
            return visitor.allowInternet(value.allowInternet);
        if (value.connectRubric !== undefined)
            return visitor.connectRubric(value.connectRubric);
        if (value.weight !== undefined)
            return visitor.weight(value.weight);
        if (value.checkstyle !== undefined)
            return visitor.checkstyle(value.checkstyle);
        if (value.javaCompile !== undefined)
            return visitor.javaCompile(value.javaCompile);
        if (value.junit5 !== undefined)
            return visitor.junit5(value.junit5);
        if (value.customTest !== undefined)
            return visitor.customTest(value.customTest);
        if (value.testTimeoutEach !== undefined)
            return visitor.testTimeoutEach(value.testTimeoutEach);
        if (value.flake8 !== undefined)
            return visitor.flake8(value.flake8);
        if (value.pytest !== undefined)
            return visitor.pytest(value.pytest);
        if (value.simplePythonTest !== undefined)
            return visitor.simplePythonTest(value.simplePythonTest);
        if (value.jupyterNotebook !== undefined)
            return visitor.jupyterNotebook(value.jupyterNotebook);
        if (value.runInNotebook !== undefined)
            return visitor.runInNotebook(value.runInNotebook);
        if (value.output !== undefined)
            return visitor.output(value.output);
        if (value.testUploadFiles !== undefined)
            return visitor.testUploadFiles(value.testUploadFiles);
        if (value.snapshot !== undefined)
            return visitor.snapshot(value.snapshot);
        if (value.ioTest !== undefined)
            return visitor.ioTest(value.ioTest);
        if (value.simpleMatch !== undefined)
            return visitor.simpleMatch(value.simpleMatch);
        if (value.regexMatch !== undefined)
            return visitor.regexMatch(value.regexMatch);
        if (value.substringMatch !== undefined)
            return visitor.substringMatch(value.substringMatch);
        if (value.codeStructureTest !== undefined)
            return visitor.codeStructureTest(value.codeStructureTest);
        if (value.negativeMatch !== undefined)
            return visitor.negativeMatch(value.negativeMatch);
        if (value.positiveMatch !== undefined)
            return visitor.positiveMatch(value.positiveMatch);
        if (value.quiz !== undefined)
            return visitor.quiz(value.quiz);
        if (value.codingQuestion !== undefined)
            return visitor.codingQuestion(value.codingQuestion);
        if (value.promptEngineeringQuestion !== undefined)
            return visitor.promptEngineeringQuestion(value.promptEngineeringQuestion);
        if (value.mcq !== undefined)
            return visitor.mcq(value.mcq);
        if (value.selectAllQuestion !== undefined)
            return visitor.selectAllQuestion(value.selectAllQuestion);
        if (value.program !== undefined)
            return visitor.program(value.program);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestTestStepOutput || (exports.AutoTestTestStepOutput = AutoTestTestStepOutput = {}));
